export const valueCell = (record) => {
	if(!record && record !== 0)
		record = '--'
	return (
		<span>{record}</span>
	)
}